import { Routes } from '@angular/router';
import { AuthenticationComponent } from './authentication/authentication.component';
import { ConfirmEmailComponent } from './authentication/confirm-email/confirm-email.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { LockScreenComponent } from './authentication/lock-screen/lock-screen.component';
import { LogoutComponent } from './authentication/logout/logout.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { SignInComponent } from './authentication/sign-in/sign-in.component';
import { SignUpComponent } from './authentication/sign-up/sign-up.component';
import { MyProfileComponent } from './functional-modules/admin/my-profile/my-profile.component';
import { CalendarComponent } from './functional-modules/calendar/calendar.component';
import { GroupManagementComponent } from './functional-modules/group/group-management/group-management.component';
import { CrmComponent } from './functional-modules/login-dashboard/dashboard/crm/crm.component';
import { TrainingPlanchartComponent } from './functional-modules/login-dashboard/dashboard/crm/training-planchart/training-planchart.component';
import { DashboardComponent } from './functional-modules/login-dashboard/dashboard/dashboard.component';
import { TargetChartComponent } from './functional-modules/login-dashboard/dashboard/target-chart/target-chart.component';
import { FrontPagesComponent } from './functional-modules/login-dashboard/front-pages/front-pages.component';
import { HomeComponent } from './functional-modules/login-dashboard/front-pages/home/home.component';
import { AccountSettingsComponent } from './functional-modules/settings/account-settings/account-settings.component';
import { ChangePasswordComponent } from './functional-modules/settings/change-password/change-password.component';
import { ConnectionsComponent } from './functional-modules/settings/connections/connections.component';
import { PrivacyPolicyComponent } from './functional-modules/settings/privacy-policy/privacy-policy.component';
import { SettingsComponent } from './functional-modules/settings/settings.component';
import { TermsConditionsComponent } from './functional-modules/settings/terms-conditions/terms-conditions.component';
import { TainingPlanDetailsComponent } from './functional-modules/tms/training-transaction/taining-plan-details/taining-plan-details.component';
import { TrainerHistoryComponent } from './functional-modules/tms/training-transaction/trainer-history/trainer-history.component';
import { TrainingPlanExecutionComponent } from './functional-modules/tms/training-transaction/training-plan-execution/training-plan-execution.component';
import { MobileViewComponent } from './responsive/mobile-view/mobile-view.component';
import { AreaChartsComponent } from './shared-components/charts/area-charts/area-charts.component';
import { ChartsComponent } from './shared-components/charts/charts.component';
import { ColumnChartsComponent } from './shared-components/charts/column-charts/column-charts.component';
import { LineChartsComponent } from './shared-components/charts/line-charts/line-charts.component';
import { MixedChartsComponent } from './shared-components/charts/mixed-charts/mixed-charts.component';
import { MoreChartsComponent } from './shared-components/charts/more-charts/more-charts.component';
import { PieChartsComponent } from './shared-components/charts/pie-charts/pie-charts.component';
import { PolarChartsComponent } from './shared-components/charts/polar-charts/polar-charts.component';
import { RadarChartsComponent } from './shared-components/charts/radar-charts/radar-charts.component';
import { RadialbarChartsComponent } from './shared-components/charts/radialbar-charts/radialbar-charts.component';
import { CheckboxesRadiosComponent } from './shared-components/forms/checkboxes-radios/checkboxes-radios.component';
import { FileUploaderComponent } from './shared-components/forms/file-uploader/file-uploader.component';
import { FormsComponent } from './shared-components/forms/forms.component';
import { InputSelectComponent } from './shared-components/forms/input-select/input-select.component';
import { RichTextEditorComponent } from './shared-components/forms/rich-text-editor/rich-text-editor.component';
import { AppsComponent } from './template-components/apps/apps.component';
import { MenuBuilder } from './ui-framework/global-services/models/menu-builder';
//import { AttendanceEntryComponent } from './functional-modules/tms/training-transaction/attendance-entry/attendance-entry.component';
import { AboutUsComponent } from './functional-modules/login-dashboard/front-pages/about-us/about-us.component';
import { ContactUsComponent } from './functional-modules/login-dashboard/front-pages/contact-us/contact-us.component';
//import { TrainingAssesmentDetailsComponent } from './functional-modules/tms/training-transaction/training-assesment-details/training-assesment-details.component';
import { ComplitionDetailsComponent } from './functional-modules/tms/training-transaction/complition-details/complition-details.component';
import { ActualCostDetailsComponent } from './functional-modules/tms/training-transaction/actual-cost-details/actual-cost-details.component';
import { authGuardChildGuard, authGuardGuard, authGuardMatchGuard } from './ui-framework/global-services/auth-guard.guard';
// import { ContactUsComponent } from './functional-modules/login-dashboard/front-pages/contact-us/contact-us.component';

export const routes: Routes = [

    {
        path: 'training-assessment',
        loadComponent: () => import('./functional-modules/tms/training-transaction/plan-attendance/attendance-qr-feedback/attendance-qr-feedback.component')
            .then(m => m.AttendanceQrFeedbackComponent)
    },

    {
        path: '',
        component: FrontPagesComponent,
        children: [
            { path: '', component: HomeComponent }
        ]
    },

    {
        path: 'dashboard',
        component: DashboardComponent,
        canMatch: [authGuardMatchGuard],
        canActivate: [authGuardGuard],
        canActivateChild: [authGuardChildGuard],
        children: [
            // ── New TMS Dashboard – default home page after login ──
            {
                path: '',
                loadComponent: () => import('./functional-modules/tms/tms-dashboard/tms-dashboard.component')
                    .then(m => m.TmsDashboardComponent)
            },
            {
                path: MenuBuilder.TrainingSetupModule,
                loadChildren: () => import('./functional-modules/tms/setup/training-setup.routing')
                    .then(m => m.TRAINING_SETUP_ROUTES)
            },
            {
                path: MenuBuilder.TrainingMasterModule,
                loadChildren: () => Promise.all([
                    import('./functional-modules/tms/allmaster/training-master.routing'),
                    import('./functional-modules/tms/training-transaction/training-transaction.routing')
                ]).then(([master, transaction]) => [
                    ...master.TRAINING_MASTER_ROUTES,
                    ...transaction.TRAINING_TRANSACTION_ROUTES
                ])
            },
            {
                path: MenuBuilder.TrainingReport,
                loadChildren: () => import('./functional-modules/tms/report/training-report.routing')
                    .then(m => m.TRAINING_REPORT_ROUTES)
            },
            {
                path: MenuBuilder.AdminModule,
                loadChildren: () => import('./functional-modules/admin/admin.routing')
                    .then(m => m.ADMIN_ROUTES)
            },
            { path: 'crm', component: CrmComponent },
            {
                path: 'apps',
                component: AppsComponent,
                children: [
                    // { path: '', component: ToDoListComponent },
                    { path: 'calendar', component: CalendarComponent },
                ]
            },


            { path: 'training-plan-execution', component: TrainingPlanExecutionComponent },

            { path: 'training-planchart', component: TrainingPlanchartComponent },
            { path: 'training-plan-details', component: TainingPlanDetailsComponent },
            // {path : 'attendance-entry', component: AttendanceEntryComponent },

            { path: 'app-trainer-history', component: TrainerHistoryComponent },

            { path: 'training-calender', component: CalendarComponent },

            // { path: 'training-assessment-details', component: TrainingAssesmentDetailsComponent },

            { path: 'complition-details', component: ComplitionDetailsComponent },

            { path: 'actual-cost-details', component: ActualCostDetailsComponent },

            { path: 'group-creation', component: GroupManagementComponent },

            /*responsive-part*/
            { path: 'mobile-view', component: MobileViewComponent },


            {
                path: 'charts',
                component: ChartsComponent,
                children: [
                    { path: '', component: LineChartsComponent },
                    { path: 'area', component: AreaChartsComponent },
                    { path: 'column', component: ColumnChartsComponent },
                    { path: 'mixed', component: MixedChartsComponent },
                    { path: 'radialbar', component: RadialbarChartsComponent },
                    { path: 'radar', component: RadarChartsComponent },
                    { path: 'pie', component: PieChartsComponent },
                    { path: 'polar', component: PolarChartsComponent },
                    { path: 'more', component: MoreChartsComponent },
                ]
            },

            {
                path: 'forms',
                component: FormsComponent,
                children: [
                    { path: '', component: InputSelectComponent },
                    { path: 'checkboxes-radios', component: CheckboxesRadiosComponent },
                    { path: 'rich-text-editor', component: RichTextEditorComponent },
                    { path: 'file-uploader', component: FileUploaderComponent }
                ]
            },
            { path: 'my-profile', component: MyProfileComponent },
            {
                path: 'settings',
                component: SettingsComponent,
                children: [
                    { path: '', component: AccountSettingsComponent },
                    { path: 'change-password', component: ChangePasswordComponent },
                    { path: 'connections', component: ConnectionsComponent },
                    { path: 'privacy-policy', component: PrivacyPolicyComponent },
                    { path: 'terms-conditions', component: TermsConditionsComponent }
                ]
            }
        ]
    },


    { path: 'about-us', component: AboutUsComponent },
    { path: 'contact-us', component: ContactUsComponent },


    { path: 'target-chart', component: TargetChartComponent },

    {
        path: 'authentication',
        component: AuthenticationComponent,
        children: [
            { path: '', component: SignInComponent },
            { path: 'sign-up', component: SignUpComponent },
            { path: 'forgot-password', component: ForgotPasswordComponent },
            { path: 'reset-password', component: ResetPasswordComponent },
            { path: 'confirm-email', component: ConfirmEmailComponent },
            { path: 'lock-screen', component: LockScreenComponent },
            { path: 'logout', component: LogoutComponent }
        ]
    },


];
